import { render, staticRenderFns } from "./DoubleAuctionBoard.vue?vue&type=template&id=01242652"
import script from "./DoubleAuctionBoard.vue?vue&type=script&lang=js"
export * from "./DoubleAuctionBoard.vue?vue&type=script&lang=js"
import style0 from "./DoubleAuctionBoard.vue?vue&type=style&index=0&id=01242652&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports